module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"doneBtnLabel":"Done"},"de":{"doneBtnLabel":"Fertig"}}')
  delete Component.options._Ctor
}
